import { isDev } from "@/config/env";

import { KAKAO_JAVASCRIPT_KEY, KAKAO_REST_API_KEY } from "./kakao.config";
import { loadKakaoSdk } from "./loadKakaoSdk";
import { resolveKakaoShareClient } from "./resolveKakaoShareClient";
import type { KakaoSdk, KakaoShareClient } from "./kakao.types";

export type InitializedKakaoSdk = KakaoSdk & {
  shareClient: KakaoShareClient;
};

export const initKakaoSdk = async (): Promise<InitializedKakaoSdk> => {
  if (!KAKAO_JAVASCRIPT_KEY) {
    throw new Error("Kakao JavaScript key is not configured.");
  }

  if (KAKAO_REST_API_KEY && KAKAO_JAVASCRIPT_KEY === KAKAO_REST_API_KEY) {
    throw new Error(
      "REACT_APP_JAVASCRIPT_API_KEY_KAKAODEV must be the JavaScript key, not the REST API key.",
    );
  }

  const Kakao = await loadKakaoSdk();

  if (!Kakao.isInitialized()) {
    Kakao.init(KAKAO_JAVASCRIPT_KEY);
  }

  if (isDev && typeof window !== "undefined") {
    console.info("[Kakao SDK] caller (register under Platform key → JavaScript key → JS SDK Domain):", {
      caller: window.location.origin,
      javascriptKeyPrefix: `${KAKAO_JAVASCRIPT_KEY.slice(0, 8)}…`,
    });
  }

  if (!Kakao.isInitialized()) {
    throw new Error("Kakao SDK failed to initialize.");
  }

  const shareClient = resolveKakaoShareClient(Kakao);

  return Object.assign(Kakao, { shareClient });
};
